// extracted by mini-css-extract-plugin
export default {"root":"ReadMoreText_root__0jV2G","readMore":"ReadMoreText_readMore__fUqLG"};